import { render, staticRenderFns } from "./folders-vessels-option-charterers-files-path.vue?vue&type=template&id=b82a0b38&scoped=true"
import script from "./folders-vessels-option-charterers-files-path.vue?vue&type=script&lang=js"
export * from "./folders-vessels-option-charterers-files-path.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b82a0b38",
  null
  
)

export default component.exports